module.exports = __webpack_public_path__ + "static/img/item3-top.30384a91.png";